// extracted by mini-css-extract-plugin
module.exports = {"mod-txt":"Text_mod-txt__2f1ul","lede":"Text_lede__3PWIZ","of-small":"Text_of-small__2cKLa","mod-txt-label":"Text_mod-txt-label__1zrO6","type-step":"Text_type-step__3H0wd"};